/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Aug 05 2021, 14:04:58
 *******************************************************/
// @flow

import mixpanel from 'mixpanel-browser';

import { integrations } from 'src/config';

mixpanel.init(integrations.mixpanel.projectKey, {
  debug: integrations.mixpanel.debug
});

mixpanel.init(integrations.mixpanelV3.projectKey, {
  debug: integrations.mixpanelV3.debug
},'AISearchAndDiscovery');

export default mixpanel;
